import toolbarStore from "@/store/toolbar.js";

export default {
  computed: toolbarStore.getters,
  methods: toolbarStore.actions,
};
